import Svg from 'components/utilities/svg'

const EditOffIcon = ({ ...props }) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <title>Edit Off Icon</title>
    <path d="m19.1 21.875-6.375-6.35L7.25 21H3v-4.25l5.475-5.475L2.1 4.9l1.45-1.425 16.975 17Zm-3.525-9.2-4.25-4.25L13.6 6.15l4.25 4.25Zm3.725-3.75-4.25-4.2 1.4-1.4q.575-.575 1.413-.575.837 0 1.412.575l1.4 1.4q.575.575.6 1.388.025.812-.55 1.387Z" />
  </Svg>
)

EditOffIcon.displayName = 'EditOff'

export default EditOffIcon
